import { EventCatalogFromKeys, EventType } from "../../../types";

export const NeedsAnalyticsEventKeys = {
  ADMIN_NEEDS_ANALYTICS_PAGE_VIEW: "admin-needs-analytics-page-view",
  ADMIN_NEEDS_ANALYTICS_TAB_CHANGE: "admin-needs-analytics-tab-change",
  NEEDS_ANALYTICS_CLIENT_DIMENSION_TYPE_CHANGE:
    "needs-analytics-client-dimension-type-change",
  NEEDS_ANALYTICS_CLIENT_EXPORT: "needs-analytics-client-export",
  NEEDS_ANALYTICS_CLIENT_REFRESH: "needs-analytics-client-refresh",
  NEEDS_ANALYTICS_CLIENT_TIMEFRAME_CHANGE:
    "needs-analytics-client-timeframe-change",
} as const;

export const NeedsAnalyticsEventCatalog: EventCatalogFromKeys<
  typeof NeedsAnalyticsEventKeys
> = {
  [NeedsAnalyticsEventKeys.ADMIN_NEEDS_ANALYTICS_PAGE_VIEW]: {
    description: "Admin viewed the needs analytics page",
    eventType: EventType.PAGE_VIEW,
    id: NeedsAnalyticsEventKeys.ADMIN_NEEDS_ANALYTICS_PAGE_VIEW,
  },
  [NeedsAnalyticsEventKeys.ADMIN_NEEDS_ANALYTICS_TAB_CHANGE]: {
    description: "Admin changed tab in needs analytics report tabs",
    eventType: EventType.INTERACTION,
    id: NeedsAnalyticsEventKeys.ADMIN_NEEDS_ANALYTICS_TAB_CHANGE,
  },
  [NeedsAnalyticsEventKeys.NEEDS_ANALYTICS_CLIENT_DIMENSION_TYPE_CHANGE]: {
    description: "User changed dimension type in NeedsAnalyticsClient",
    eventType: EventType.INTERACTION,
    id: NeedsAnalyticsEventKeys.NEEDS_ANALYTICS_CLIENT_DIMENSION_TYPE_CHANGE,
  },
  [NeedsAnalyticsEventKeys.NEEDS_ANALYTICS_CLIENT_EXPORT]: {
    description: "User exported data in NeedsAnalyticsClient",
    eventType: EventType.INTERACTION,
    id: NeedsAnalyticsEventKeys.NEEDS_ANALYTICS_CLIENT_EXPORT,
  },
  [NeedsAnalyticsEventKeys.NEEDS_ANALYTICS_CLIENT_REFRESH]: {
    description: "User refreshed data in NeedsAnalyticsClient",
    eventType: EventType.INTERACTION,
    id: NeedsAnalyticsEventKeys.NEEDS_ANALYTICS_CLIENT_REFRESH,
  },
  [NeedsAnalyticsEventKeys.NEEDS_ANALYTICS_CLIENT_TIMEFRAME_CHANGE]: {
    description: "User changed time frame in NeedsAnalyticsClient",
    eventType: EventType.INTERACTION,
    id: NeedsAnalyticsEventKeys.NEEDS_ANALYTICS_CLIENT_TIMEFRAME_CHANGE,
  },
};
